<template>
    <v-app>
        <v-main>
            <v-container class="fill-height d-flex justify-center align-center">
                <slot />
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'LoginLayout'
}
</script>
